import React from "react";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import { ModalPickerProps } from "../props";
import ClientList from "./ClientList";
import RemovableClient from "components/Removables/RemovableClient";

interface Props extends ModalPickerProps<server.dto.ClientSmall> {
  preferredClients: server.dto.ClientSmall[]
}


const ClientModalPicker = (props: Props) => {
  const { preferredClients, ...rest } = props;
  const onChange = (value: server.dto.ClientSmall) => {
    props.nonInPageEditing?.onChange(value);
    props.inPageEditing?.onChange(value, true);
  };
  return <ModalPickerWithChooseButton
    buttonLabel={RESX.Buttons.btnSelect}
    modalTitle={"Clients"}
    modalSize="tiny"
    renderModalContent={(closeModal) => <ClientList
      preferredClients={props.preferredClients}
      onItemSelected={(client) => {
        closeModal();
        onChange(client);
      }}
    />}
    renderRemovable={(props) => <RemovableClient {...props} />}
    onNewClicked={() => { }}
    {...rest}
  />;
};

export default ClientModalPicker;